The HTTPS URI that the candidate accesses to apply for the position.
